import React, { useEffect, useState } from "react";
import { Button } from "@vibe/core";

import SettingsCard from "./settings-ui-components/SettingsCard";
import { SettingSwitch } from "../SettingSwitch";
import SettingsTitle from "./settings-ui-components/SettingsTitle";
import { useItemSettings } from "../../../../hooks/api";
import useBoardAndItems from "../../../../hooks/context/useBoardAndItems";
import useTokenHook from "../../../../hooks/context/useTokenHook";
import { useItemName } from "../../../../hooks/api/useItemName";
import { MergeItemFlow } from "../../../MergeItem";

const ItemSettings = () => {
  const { itemIds, currentBoard } = useBoardAndItems();
  const { token } = useTokenHook();
  const { itemName } = useItemName(itemIds ?? undefined);
  const [showMerge, setShowMerge] = useState(false);
  const { itemSettings, updateSettings } = useItemSettings(itemIds!.map(String) ?? []);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [switchValues, setSwitchValues] = useState(itemSettings);

  useEffect(() => {
    if (itemSettings) {
      setSwitchValues(itemSettings);
    }
  }, [itemSettings]);

  const currentItemId = itemIds?.[0] != null ? String(itemIds[0]) : "";

  if (showMerge && currentItemId && currentBoard) {
    return (
      <MergeItemFlow
        token={token}
        currentItemId={currentItemId}
        currentBoardId={String(currentBoard)}
        currentItemName={itemName || "this item"}
        onClose={() => setShowMerge(false)}
      />
    );
  }

  return (
    <div className="space-y-4">
      <SettingsTitle title="Item Settings" subtitle="Manage item settings for the current item you are in." />
      <SettingsCard>
        <div className="space-y-2">
          <SettingSwitch
            label="Share updates posted in this item"
            settingKey="sharedUpdates"
            setNewValue={setSwitchValues}
            initialValue={itemSettings?.sharedUpdates}
            tooltip="This will enable or disable updates from being shared to other boards."
            updateFunction={(value) => updateSettings("sharedUpdates", value)}
          />
          <SettingSwitch
            label="Share subitems created in this item"
            settingKey="sharedSubitems"
            setNewValue={setSwitchValues}
            initialValue={itemSettings?.sharedSubitems}
            tooltip="This will enable or disable created subitems from being shared to other boards."
            updateFunction={(value) => updateSettings("sharedSubitems", value)}
          />
        </div>
      </SettingsCard>
      <SettingsCard>
        <div className="flex flex-col gap-3">
          <div className="space-y-1">
            <h3 className="font-medium">Merge with an existing item</h3>
            <p className="text-sm text-light-secondary-text-color">
              Link this item to one that already exists on another board. No new item is created. From then on, the
              two stay in sync.
            </p>
          </div>
          <div className="flex justify-end">
            <Button
              kind="secondary"
              onClick={() => setShowMerge(true)}
              disabled={!currentItemId || !currentBoard}
            >
              Merge this item with another item
            </Button>
          </div>
        </div>
      </SettingsCard>
    </div>
  );
};

export default ItemSettings;
